import { n as _, i as oe, a as ne, t as x, b as re, c as k, f as X, g as se, u as le, h as ce } from "./index-CG0-5z0S.js";
import { watch as I, reactive as P, ref as T, computed as E, nextTick as ie, shallowRef as ue, getCurrentInstance as ae, onMounted as fe } from "vue";
function w(e) {
  var t;
  const o = x(e);
  return (t = o?.$el) != null ? t : o;
}
const W = ne ? window : void 0;
function V(...e) {
  let t, o, n, l;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([o, n, l] = e, t = W) : [t, o, n, l] = e, !t)
    return _;
  Array.isArray(o) || (o = [o]), Array.isArray(n) || (n = [n]);
  const i = [], a = () => {
    i.forEach((h) => h()), i.length = 0;
  }, c = (h, s, r, u) => (h.addEventListener(s, r, u), () => h.removeEventListener(s, r, u)), v = I(
    () => [w(t), x(l)],
    ([h, s]) => {
      if (a(), !h)
        return;
      const r = re(s) ? { ...s } : s;
      i.push(
        ...o.flatMap((u) => n.map((f) => c(h, u, f, r)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    v(), a();
  };
  return k(d), d;
}
let G = !1;
function Se(e, t, o = {}) {
  const { window: n = W, ignore: l = [], capture: i = !0, detectIframe: a = !1 } = o;
  if (!n)
    return _;
  oe && !G && (G = !0, Array.from(n.document.body.children).forEach((r) => r.addEventListener("click", _)), n.document.documentElement.addEventListener("click", _));
  let c = !0;
  const v = (r) => l.some((u) => {
    if (typeof u == "string")
      return Array.from(n.document.querySelectorAll(u)).some((f) => f === r.target || r.composedPath().includes(f));
    {
      const f = w(u);
      return f && (r.target === f || r.composedPath().includes(f));
    }
  }), h = [
    V(n, "click", (r) => {
      const u = w(e);
      if (!(!u || u === r.target || r.composedPath().includes(u))) {
        if (r.detail === 0 && (c = !v(r)), !c) {
          c = !0;
          return;
        }
        t(r);
      }
    }, { passive: !0, capture: i }),
    V(n, "pointerdown", (r) => {
      const u = w(e);
      c = !v(r) && !!(u && !r.composedPath().includes(u));
    }, { passive: !0 }),
    a && V(n, "blur", (r) => {
      setTimeout(() => {
        var u;
        const f = w(e);
        ((u = n.document.activeElement) == null ? void 0 : u.tagName) === "IFRAME" && !f?.contains(n.document.activeElement) && t(r);
      }, 0);
    })
  ].filter(Boolean);
  return () => h.forEach((r) => r());
}
function de() {
  const e = T(!1), t = ae();
  return t && fe(() => {
    e.value = !0;
  }, t), e;
}
function Y(e) {
  const t = de();
  return E(() => (t.value, !!e()));
}
function ve(e, t, o = {}) {
  const { window: n = W, ...l } = o;
  let i;
  const a = Y(() => n && "ResizeObserver" in n), c = () => {
    i && (i.disconnect(), i = void 0);
  }, v = E(() => Array.isArray(e) ? e.map((s) => w(s)) : [w(e)]), d = I(
    v,
    (s) => {
      if (c(), a.value && n) {
        i = new ResizeObserver(t);
        for (const r of s)
          r && i.observe(r, l);
      }
    },
    { immediate: !0, flush: "post" }
  ), h = () => {
    c(), d();
  };
  return k(h), {
    isSupported: a,
    stop: h
  };
}
function he(e, t = { width: 0, height: 0 }, o = {}) {
  const { window: n = W, box: l = "content-box" } = o, i = E(() => {
    var s, r;
    return (r = (s = w(e)) == null ? void 0 : s.namespaceURI) == null ? void 0 : r.includes("svg");
  }), a = T(t.width), c = T(t.height), { stop: v } = ve(
    e,
    ([s]) => {
      const r = l === "border-box" ? s.borderBoxSize : l === "content-box" ? s.contentBoxSize : s.devicePixelContentBoxSize;
      if (n && i.value) {
        const u = w(e);
        if (u) {
          const f = u.getBoundingClientRect();
          a.value = f.width, c.value = f.height;
        }
      } else if (r) {
        const u = Array.isArray(r) ? r : [r];
        a.value = u.reduce((f, { inlineSize: g }) => f + g, 0), c.value = u.reduce((f, { blockSize: g }) => f + g, 0);
      } else
        a.value = s.contentRect.width, c.value = s.contentRect.height;
    },
    o
  );
  X(() => {
    const s = w(e);
    s && (a.value = "offsetWidth" in s ? s.offsetWidth : t.width, c.value = "offsetHeight" in s ? s.offsetHeight : t.height);
  });
  const d = I(
    () => w(e),
    (s) => {
      a.value = s ? t.width : 0, c.value = s ? t.height : 0;
    }
  );
  function h() {
    v(), d();
  }
  return {
    width: a,
    height: c,
    stop: h
  };
}
function pe(e, t, o = {}) {
  const {
    root: n,
    rootMargin: l = "0px",
    threshold: i = 0.1,
    window: a = W,
    immediate: c = !0
  } = o, v = Y(() => a && "IntersectionObserver" in a), d = E(() => {
    const f = x(e);
    return (Array.isArray(f) ? f : [f]).map(w).filter(ce);
  });
  let h = _;
  const s = T(c), r = v.value ? I(
    () => [d.value, w(n), s.value],
    ([f, g]) => {
      if (h(), !s.value || !f.length)
        return;
      const y = new IntersectionObserver(
        t,
        {
          root: w(g),
          rootMargin: l,
          threshold: i
        }
      );
      f.forEach((m) => m && y.observe(m)), h = () => {
        y.disconnect(), h = _;
      };
    },
    { immediate: c, flush: "post" }
  ) : _, u = () => {
    h(), r(), s.value = !1;
  };
  return k(u), {
    isSupported: v,
    isActive: s,
    pause() {
      h(), s.value = !1;
    },
    resume() {
      s.value = !0;
    },
    stop: u
  };
}
function me(e, t = {}) {
  const { window: o = W, scrollTarget: n, threshold: l = 0 } = t, i = T(!1);
  return pe(
    e,
    (a) => {
      let c = i.value, v = 0;
      for (const d of a)
        d.time >= v && (v = d.time, c = d.isIntersecting);
      i.value = c;
    },
    {
      root: n,
      window: o,
      threshold: l
    }
  ), i;
}
const N = 1;
function ge(e, t = {}) {
  const {
    throttle: o = 0,
    idle: n = 200,
    onStop: l = _,
    onScroll: i = _,
    offset: a = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: c = {
      capture: !1,
      passive: !0
    },
    behavior: v = "auto",
    window: d = W,
    onError: h = (p) => {
      console.error(p);
    }
  } = t, s = T(0), r = T(0), u = E({
    get() {
      return s.value;
    },
    set(p) {
      g(p, void 0);
    }
  }), f = E({
    get() {
      return r.value;
    },
    set(p) {
      g(void 0, p);
    }
  });
  function g(p, R) {
    var L, M, C, A;
    if (!d)
      return;
    const S = x(e);
    if (!S)
      return;
    (C = S instanceof Document ? d.document.body : S) == null || C.scrollTo({
      top: (L = x(R)) != null ? L : f.value,
      left: (M = x(p)) != null ? M : u.value,
      behavior: x(v)
    });
    const H = ((A = S?.document) == null ? void 0 : A.documentElement) || S?.documentElement || S;
    u != null && (s.value = H.scrollLeft), f != null && (r.value = H.scrollTop);
  }
  const y = T(!1), m = P({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), b = P({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), z = (p) => {
    y.value && (y.value = !1, b.left = !1, b.right = !1, b.top = !1, b.bottom = !1, l(p));
  }, te = le(z, o + n), D = (p) => {
    var R;
    if (!d)
      return;
    const L = ((R = p?.document) == null ? void 0 : R.documentElement) || p?.documentElement || w(p), { display: M, flexDirection: C } = getComputedStyle(L), A = L.scrollLeft;
    b.left = A < s.value, b.right = A > s.value;
    const S = Math.abs(A) <= (a.left || 0), H = Math.abs(A) + L.clientWidth >= L.scrollWidth - (a.right || 0) - N;
    M === "flex" && C === "row-reverse" ? (m.left = H, m.right = S) : (m.left = S, m.right = H), s.value = A;
    let O = L.scrollTop;
    p === d.document && !O && (O = d.document.body.scrollTop), b.top = O < r.value, b.bottom = O > r.value;
    const $ = Math.abs(O) <= (a.top || 0), F = Math.abs(O) + L.clientHeight >= L.scrollHeight - (a.bottom || 0) - N;
    M === "flex" && C === "column-reverse" ? (m.top = F, m.bottom = $) : (m.top = $, m.bottom = F), r.value = O;
  }, B = (p) => {
    var R;
    if (!d)
      return;
    const L = (R = p.target.documentElement) != null ? R : p.target;
    D(L), y.value = !0, te(p), i(p);
  };
  return V(
    e,
    "scroll",
    o ? se(B, o, !0, !1) : B,
    c
  ), X(() => {
    try {
      const p = x(e);
      if (!p)
        return;
      D(p);
    } catch (p) {
      h(p);
    }
  }), V(
    e,
    "scrollend",
    z,
    c
  ), {
    x: u,
    y: f,
    isScrolling: y,
    arrivedState: m,
    directions: b,
    measure() {
      const p = x(e);
      d && p && D(p);
    }
  };
}
function be(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function xe(e, t, o = {}) {
  var n;
  const {
    direction: l = "bottom",
    interval: i = 100,
    canLoadMore: a = () => !0
  } = o, c = P(ge(
    e,
    {
      ...o,
      offset: {
        [l]: (n = o.distance) != null ? n : 0,
        ...o.offset
      }
    }
  )), v = T(), d = E(() => !!v.value), h = E(() => be(x(e))), s = me(h);
  function r() {
    if (c.measure(), !h.value || !s.value || !a(h.value))
      return;
    const { scrollHeight: u, clientHeight: f, scrollWidth: g, clientWidth: y } = h.value, m = l === "bottom" || l === "top" ? u <= f : g <= y;
    (c.arrivedState[l] || m) && (v.value || (v.value = Promise.all([
      t(c),
      new Promise((b) => setTimeout(b, i))
    ]).finally(() => {
      v.value = null, ie(() => r());
    })));
  }
  return I(
    () => [c.arrivedState[l], s.value],
    r,
    { immediate: !0 }
  ), {
    isLoading: d
  };
}
function _e(e, t) {
  const { containerStyle: o, wrapperProps: n, scrollTo: l, calculateRange: i, currentList: a, containerRef: c } = "itemHeight" in t ? Ee(t, e) : ye(t, e);
  return {
    list: a,
    scrollTo: l,
    containerProps: {
      ref: c,
      onScroll: () => {
        i();
      },
      style: o
    },
    wrapperProps: n
  };
}
function j(e) {
  const t = T(null), o = he(t), n = T([]), l = ue(e);
  return { state: T({ start: 0, end: 10 }), source: l, currentList: n, size: o, containerRef: t };
}
function q(e, t, o) {
  return (n) => {
    if (typeof o == "number")
      return Math.ceil(n / o);
    const { start: l = 0 } = e.value;
    let i = 0, a = 0;
    for (let c = l; c < t.value.length; c++) {
      const v = o(c);
      if (i += v, a = c, i > n)
        break;
    }
    return a - l;
  };
}
function K(e, t) {
  return (o) => {
    if (typeof t == "number")
      return Math.floor(o / t) + 1;
    let n = 0, l = 0;
    for (let i = 0; i < e.value.length; i++) {
      const a = t(i);
      if (n += a, n >= o) {
        l = i;
        break;
      }
    }
    return l + 1;
  };
}
function U(e, t, o, n, { containerRef: l, state: i, currentList: a, source: c }) {
  return () => {
    const v = l.value;
    if (v) {
      const d = o(e === "vertical" ? v.scrollTop : v.scrollLeft), h = n(e === "vertical" ? v.clientHeight : v.clientWidth), s = d - t, r = d + h + t;
      i.value = {
        start: s < 0 ? 0 : s,
        end: r > c.value.length ? c.value.length : r
      }, a.value = c.value.slice(i.value.start, i.value.end).map((u, f) => ({
        data: u,
        index: f + i.value.start
      }));
    }
  };
}
function J(e, t) {
  return (o) => typeof e == "number" ? o * e : t.value.slice(0, o).reduce((l, i, a) => l + e(a), 0);
}
function Q(e, t, o, n) {
  I([e.width, e.height, t, o], () => {
    n();
  });
}
function Z(e, t) {
  return E(() => typeof e == "number" ? t.value.length * e : t.value.reduce((o, n, l) => o + e(l), 0));
}
const we = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function ee(e, t, o, n) {
  return (l) => {
    n.value && (n.value[we[e]] = o(l), t());
  };
}
function ye(e, t) {
  const o = j(t), { state: n, source: l, currentList: i, size: a, containerRef: c } = o, v = { overflowX: "auto" }, { itemWidth: d, overscan: h = 5 } = e, s = q(n, l, d), r = K(l, d), u = U("horizontal", h, r, s, o), f = J(d, l), g = E(() => f(n.value.start)), y = Z(d, l);
  Q(a, t, c, u);
  const m = ee("horizontal", u, f, c), b = E(() => ({
    style: {
      height: "100%",
      width: `${y.value - g.value}px`,
      marginLeft: `${g.value}px`,
      display: "flex"
    }
  }));
  return {
    scrollTo: m,
    calculateRange: u,
    wrapperProps: b,
    containerStyle: v,
    currentList: i,
    containerRef: c
  };
}
function Ee(e, t) {
  const o = j(t), { state: n, source: l, currentList: i, size: a, containerRef: c } = o, v = { overflowY: "auto" }, { itemHeight: d, overscan: h = 5 } = e, s = q(n, l, d), r = K(l, d), u = U("vertical", h, r, s, o), f = J(d, l), g = E(() => f(n.value.start)), y = Z(d, l);
  Q(a, t, c, u);
  const m = ee("vertical", u, f, c), b = E(() => ({
    style: {
      width: "100%",
      height: `${y.value - g.value}px`,
      marginTop: `${g.value}px`
    }
  }));
  return {
    calculateRange: u,
    scrollTo: m,
    containerStyle: v,
    wrapperProps: b,
    currentList: i,
    containerRef: c
  };
}
export {
  xe as a,
  he as b,
  Se as o,
  _e as u
};
